/**
 * /tenants/{slug}/applications/dynamic-registration — automated
 * OIDC onboarding policy route.
 *
 * Compatibility redirect to the tenant-wide policy under Settings.
 *
 * Bookmark compatibility: the old /tenants/{slug}/oauth-dynreg
 * URL still resolves; its route definition issues a redirect()
 * to
 *
 * The page itself (features/oauth-dynreg/pages/dynreg-page.tsx)
 * uses `routeApi.useRouteContext()` to read the resolved tenant.
 * This shim:
 *   - exports the routeApi the page consumes
 *   - prefetches the IAT list + policy via ensureQueryData so
 *     the page lands warm
 *   - validates the small search-param surface (just an
 *     include_revoked toggle so the list state survives a
 *     reload)
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/applications/dynamic-registration/",
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/tenants/$slug/settings/automated-onboarding",
      params: { slug: params.slug },
      search,
      replace: true,
    });
  },
});
